<p-multiSelect
  [options]="types"
  [(ngModel)]="selectedTypeIds"
  optionLabel="title"
  optionValue="id"
  placeholder="Select Types"
  (onChange)="onFilterChange()"
  [showToggleAll]="true"
  [filter]="false"
  [maxSelectedLabels]="1"
  selectedItemsLabel="{0} types"
  [selectedItemsLabel]="this.selectedTypeIds.length === types.length ? 'All types' : '{0} types'"
>
</p-multiSelect>
